import { useAuthContext } from '@providers/AuthProvider';
import { routes } from '@routes';
import { Link, useLocation } from 'react-router-dom';

import TrainingIcon from '@components/icons/Training.svg';
import { shouldShowTrainingLink } from '../../helpers/shouldShowTrainingLink';

export const WatchTraining = () => {
  const { me } = useAuthContext();
  const { pathname } = useLocation();

  if (!me || !shouldShowTrainingLink(pathname ?? '')) {
    return null;
  }

  return (
    <div className="flex justify-center">
      <Link
        to={routes.training.make()}
        className="text-[var(--color-green-text)] text-xs font-medium leading-[150%] no-underline bg-[var(--color-green)] hover:bg-[var(--color-green-hover)] px-2 py-1 rounded-[5px] min-h-9 items-center flex gap-1.5 whitespace-nowrap"
      >
        <TrainingIcon /> Training Videos
      </Link>
    </div>
  );
};
